export const BODY_TEXT_COLOR = '#616161';
export const DARK_GREY = '#484848';
export const LIGHT_GREY = '#D8D8D8';
export const NEGATIVE_COLOR = '#AFAFB1';
export const THIRD_COLOR = '#E6E6E7';
export const BLUE_COLOR = '#5697DE';
export const ERROR_COLOR = '#f44336';
export const ACCENT_COLOR = '#8bc027';
export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const BORDER_GREY = '#CFD0D2';
export const LIGHT_GREEN = '#C1DB7E';

// greens
export const BUTTON_GREEN = '#6EBE45';

// Fonts
export const FUTURA_BOLD = 'Futura-Bold, sans-serif';

export const WARNING_RED = '#EF9A9A';

// menu
export const TRANSPARENT_BACKGROUND = '#00000080';

// suggestions
export const SUGGESTIONS_BACKGROUND = 'rgba(68, 68, 68, 0.9)';

// reds
export const DARK_RED = '#d65858';



// WEBPACK FOOTER //
// ./src/config/colors.js